import { createStore, combineReducers, applyMiddleware } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'
import CurrentReducer from './current/reducer'
import ProductMetaReducer from './routes/product_manager/v2/reducer'

let devTools = middleware => middleware
if (import.meta.env.MODE !== 'production') {
  // eslint-disable-next-line global-require
  devTools = composeWithDevTools
}

export const rootReducer = combineReducers({
  current: CurrentReducer,
  productMeta: ProductMetaReducer
  // your reducers here
})

export type AppState = ReturnType<typeof rootReducer>

const middlewares = [thunkMiddleware]
const middleWareEnhancer = applyMiddleware(...middlewares)
const store = createStore(rootReducer, devTools(middleWareEnhancer))

export default store
